<template>
  <div class="header">
    <div class="home_msg">
      <p>您好，欢迎进入天津市天科云创科技有限公司官方网站！</p>
    </div>
    <div class="logo_msg">
      <div class="logo">
        <router-link to="/home">
          <img src="../assets/company.jpg" />
        </router-link>
      </div>

      <i class="el-icon-menu" @click="showMenu"></i>

      <el-divider direction="vertical"></el-divider>
      <div class="msg">
        <p class="msg1">
          精通<span>高多层线路板、陶瓷新材料、新能源充电桩</span>等多个领域的研发
        </p>
        <p class="msg2">行业科技领先领跑者</p>
      </div>
      <div class="phone">
        <div class="phone_icon">
          <img src="../assets/phone.png" />
        </div>
        <div class="phone_msg">
          <p class="phone_msg1">全国咨询热线：</p>
          <p class="phone_msg2">{{ company[0].phone }}</p>
        </div>
      </div>
    </div>
    <div class="menu" :style="styleMenu">
      <ul>
        <li
          v-for="(item, index) in items"
          :key="index"
          @click="showToggle(item, item.name)"
          :class="{ active: $route.meta.active == item.name }"
        >
          <router-link :to="item.link">
            {{ item.name }}
          </router-link>
          <ul v-if="item.isSubshow" ref="clickBox">
            <li
              v-for="(subItem, index) in item.subItems"
              :class="{ on: childindex == subItem.checkindex }"
              @click="clickchild(subItem)"
              :key="index"
            >
              <router-link :to="subItem.link">
                {{ subItem.name }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderView",
  data() {
    return {
      active: "天科首页",
      childindex: "",
      items: [
        {
          name: "天科首页",
          link: "/home",
        },
        {
          name: "公司简介",
          link: "/company",
        },
        {
          name: "产品展示",
          isSubshow: false,
          link: "",
          subItems: [
            {
              name: "线路板产品",
              checkindex: 13,
              link: "/product/pcb",
            },
            {
              name: "新能源产品",
              checkindex: 14,
              link: "/product/NE",
            },
          ],
        },
        {
          name: "产品服务",
          link: "/serve",
        },
        {
          name: "证书资质",
          link: "/credit",
        },
        {
          name: "新闻中心",
          link: "/news",
        },
        {
          name: "合作伙伴",
          link: "/cooperate",
        },
        {
          name: "联系我们",
          link: "/connect",
        },
      ],
      styleMenu: {
        display: "",
      },
      company:[]
    };
  },
  methods: {
    showToggle: function (item, name) {
      if (item.subItems) {
        item.isSubshow = !item.isSubshow;
      } else {
        item.isSubshow = false;
        this.active = name;
      }
    },
    clickchild(subItem) {
      this.childindex = subItem.checkindex;
    },
    showMenu() {
      if (this.styleMenu.display != "block") {
        this.styleMenu.display = "block";
      } else if (this.styleMenu.display != "none") {
        this.styleMenu.display = "none";
      }
    },
    getCompany() {
      this.$axios.get("/company").then((res) => {
        this.company = res.data.data;
      });
    },
  },
  created() {
    this.getCompany();
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: column;
  height: auto;
}
.home_msg {
  width: 100%;
  height: 60px;
  background-color: rgba(220, 220, 220, 0.9);
  color: white;
  font-size: 22px;
  text-align: left;
  display: flex;
  p {
    margin: 5px;
    line-height: 50px;
    width: 70%;
  }
  span {
    margin: 5px;
    line-height: 50px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}
.logo_msg {
  display: flex;
  i {
    display: none;
    @media screen and (max-width: 768px) {
      display: block;
      width: 15%;
      font-size: 2rem;
      line-height: 120px;
      text-align: right;
    }
  }
}
.logo {
  width: 20%;
  line-height: 60px;
  display: flex;
  align-items: center;
  text-align: center;
  @media screen and (max-width: 768px) {
    text-align: center;
    width: 80%;
    margin: 0 auto;
  }
  img {
    vertical-align: middle;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    object-fit: contain;
    @media screen and (max-width: 768px) {
      text-align: center;
      justify-content: center;
    }
  }
}
::v-deep .el-divider--vertical {
  height: auto;
  @media screen and (max-width: 768px) {
    display: none;
  }
}
.msg {
  display: flex;
  flex-direction: column;
  width: 50%;
  text-align: left;
  @media screen and (max-width: 768px) {
    display: none;
  }
  .msg1 {
    font-size: 25px;
    color: black;
    span {
      color: rgb(1, 92, 181);
    }
  }
  .msg2 {
    font-size: 20px;
  }
}
.phone {
  display: flex;
  width: 30%;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
  @media screen and (max-width: 768px) {
    display: none;
  }
  .phone_icon {
    height: 150px;
    margin: 10px;
  }
  .phone_msg {
    display: flex;
    flex-direction: column;
    .phone_msg2 {
      color: rgb(1, 92, 181);
      text-align: center;
    }
  }
}
.menu {
  font-size: 20px;
  line-height: 80px;
  background: rgb(1, 92, 181);
  width: 100%;
  height: 80px;
  ul {
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      flex-direction: column;
      justify-content: center;
      padding: 0;
    }
  }
  ul li {
    list-style: none;
    cursor: pointer;
  }
  @media screen and (max-width: 768px) {
    background: rgba(109, 129, 125, 0.5);
    width: 100%;
    height: 100%;
    display: none;
  }
}
.menu ul li {
  float: left;
  /* 使列表(一级菜单)横向 */
  position: relative;
  color: white;
  vertical-align: middle;
  text-align: center;
  align-items: center;
}
.menu ul li ul {
  width: 150px;
  height: auto;
  background: rgb(1, 92, 181);
  /* 设置初始为不显示 */
  position: relative;
  z-index: 9999;
  flex-direction: column;
  justify-content: space-around;
  padding: 0;
  @media screen and (max-width: 768px) {
    width: 100%;
    transition: none;
    background-color: rgba(109, 129, 125, 0.5);
    margin: 0 auto;
  }
}
.menu ul li ul li {
  color: white;
}
::v-deep a:-webkit-any-link {
  color: white;
  text-decoration: none;
}
.active {
  background-color: darkblue;
  width: 150px;
  height: 80px;
  transition: 0.5s ease-in;
  @media screen and (max-width: 768px) {
    width: 100%;
    transition: none;
    background-color: rgb(1, 92, 181);
    margin: 0 auto;
  }
}
.on {
  background-color: darkblue;
  position: relative;
  transition: 0.5s ease-in;
  @media screen and (max-width: 768px) {
    width: 100%;
    transition: none;
    background-color: rgba(109, 129, 125, 0.5);
    margin: 0 auto;
  }
}
</style>